
'use strict';

$(document).ready(function () {
    var $sliderWrapper = $('.bonus-card-carousel');
    var $slider = $sliderWrapper.find('.carousel-inner');

    $slider.each(function () {
        var $this = $(this);
        var settings = {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $this.siblings('.arrows').find('.prev'),
            nextArrow: $this.siblings('.arrows').find('.next'),
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 490,
                    settings: {
                        slidesToShow: 1.1,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.8,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.39,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3.39,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        };

        $this.slick(settings);
        $sliderWrapper.removeClass('d-none');
    });
});
